module.exports = __webpack_public_path__ + "422e00022dc349f1311e50b29635e388.png";